/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const BANNERSTATUSFILTER = {
  VISIBLE: "VISIBLE",
  ALMOST_VISIBLE: "ALMOST_VISIBLE",
  INVISIBLE: "INVISIBLE"
} as const;
export type BANNERSTATUSFILTER = typeof BANNERSTATUSFILTER[keyof typeof BANNERSTATUSFILTER];

export function BANNERSTATUSFILTERFromJSON(json: any): BANNERSTATUSFILTER {
  return BANNERSTATUSFILTERFromJSONTyped(json, false);
}

export function BANNERSTATUSFILTERFromJSONTyped(json: any, ignoreDiscriminator: boolean): BANNERSTATUSFILTER {
  return json as BANNERSTATUSFILTER;
}

export function BANNERSTATUSFILTERToJSON(value?: BANNERSTATUSFILTER | null): any {
  return value as any;
}
